import { render, staticRenderFns } from "./ToPassRequirementSwitch.vue?vue&type=template&id=4d3f1542&scoped=true"
import script from "./ToPassRequirementSwitch.vue?vue&type=script&setup=true&lang=js"
export * from "./ToPassRequirementSwitch.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ToPassRequirementSwitch.vue?vue&type=style&index=0&id=4d3f1542&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d3f1542",
  null
  
)

export default component.exports